<div class="container" *ngIf="!loading && settings; else contentLoader">
	<app-roi-edit-modal-v2 [type]='"edit"' [currentImage]='currentImage' [damageLoad]='damages' [tchek]='tchek'
		[currentMode]='currentMode' (onSave)="handleModal($event)">
	</app-roi-edit-modal-v2>

	<!-- Header -->
	<div class="row head" id="header-damage">
		<!-- Header title + damage number -->
		<div [ngClass]="(inPlayer || !listHaveOldDamages) ? 'col-12':'col-12 col-lg-6'" class="mt-1">
			<div class="row p-0 m-0 justify-content-between">
				<div class="col* p-0 m-0">
					<span class="title" i18n="damage-analysis|@@damage_analysis">Analyse des dommages</span>
					<span class="damage-count">({{damages?.length}})</span>
				</div>
				<div class="col*  p-0 m-0 d-inline-flex justify-content-end">

					<div class="mr-1">
						<img *ngIf="tchek?.isFlagged" (click)="handleSetAsUnflagged($event, tchek)" class='icon'
							src='../../../assets/icon/warning.svg' />
						<img *ngIf="tchek?.isFlagged !== true" (click)="handleSetAsFlagged($event, tchek)" class='icon'
							src='../../../assets/icon/warning-outline.svg' />
					</div>

					<div class="mr-1">
						<img *ngIf="tchek?.kpi === true && isSuperAdmin" (click)="handleSetKpi($event, tchek, false)"
							class='icon' src='../../../assets/icon/kpi_filled.svg' />
						<img *ngIf="tchek?.kpi !== true && isSuperAdmin" (click)="handleSetKpi($event, tchek, true)"
							class='icon' src='../../../assets/icon/kpi_not_filled.svg' />
					</div>

					<div class="mr-1">
						<img *ngIf="tchek?.inspected === true" (click)="handleSetAsUnInspected($event, tchek)"
							class='icon' src='../../../assets/icon/search_filled.svg' />
						<img *ngIf="tchek?.inspected !== true" (click)="handleSetAsInspected($event, tchek)"
							class='icon' src='../../../assets/icon/search_not_filled.svg' />
					</div>


					<!-- Allert traces-->
					<div *ngIf="isSuperAdmin" class="mr-1">
						<img class="icon" *ngIf="!showTraces" (click)='showTraces = true'
							src='../../../assets/icon/alert_empty.svg'>
						<img class="icon" *ngIf="showTraces" (click)='showTraces = false'
							src='../../../assets/icon/alert_fill.svg'>
					</div>
					<!-- Filter damage settings -->
					<app-dropdown-filter-damage *ngIf="isSuperAdmin && company" [tchekId]="tchekId" [company]="company">
					</app-dropdown-filter-damage>
					<!-- Filter Damage type  -->
					<app-damage-analysis-filter [damages]="damages " *ngIf="damages && damages[0]"
						(updateFilters)='hideDamageHandler($event)'>
					</app-damage-analysis-filter>
				</div>
			</div>
		</div>

		<!-- edit immat and vehicle class -->
		<div class="col-12" *ngIf="inPlayer && tchek && tchek.vehiclePtr">
			<hr class="smallMargin">
			<div class="row p-0 m-0">
				<div class="col* col-lg-6">
					<span class="span-txt" i18n="tchek-list|@@immat">Immatriculation</span>
					<input [ngModel]="tchek.vehiclePtr.immat | uppercase" type="text" class=""
						i18n-placeholder="damage_analysis|@@matriculation" (ngModelChange)="saveImmat($event)">
				</div>
				<div class="col* col-lg-6"
					*ngIf="settingsCompany && settingsCompany.vehicle && settingsCompany.vehicle.classes">
					<span class="span-txt">Classe</span>
					<ng-select [items]="settingsCompany.vehicle.classes" [bindLabel]="'value'" [bindValue]="'display'"
						[(ngModel)]="tchek.vehiclePtr.class" [ngModelOptions]="{standalone: true}"
						[virtualScroll]='true' [searchable]='true' notFoundText="---" [clearable]='false'
						placeholder='Classe...' i18n-placeholder="parameters-cost|@@class"
						(change)="handlerChangeClassName($event)">
					</ng-select>
				</div>
				<div class="col-12" *ngIf="settings && settings.vehicle && settings.vehicle.orNumber">
					<span class="span-txt" i18n="tchek-list|@@repair_number">O.R.</span>
					<input [(ngModel)]="tchek.vehiclePtr.or" type="text" class="" i18n-placeholder="O.R"
						(ngModelChange)="saveOr()">
				</div>
			</div>
		</div>

		<!-- Show parent domages  -->
		<div [ngClass]="inPlayer? 'col-12':'col-12 col-lg-6'" class="mt-0 pt-0  text-right align-self-end"
			*ngIf="listHaveOldDamages">
			<a *ngIf="showParentDamage === false" (click)="setShowParentDamage()"><span
					i18n="damage-analysis|@@add_old_damages" class="action">Ajouter anciens dommages</span>
				<img class="parentDamage-icon" src='../../../assets/icon/plus.svg' />
			</a>
			<a *ngIf="showParentDamage === true" (click)="setShowParentDamage()"><span
					i18n="damage-analysis|@@remove_old_damages" class="action">Retirer anciens dommages</span>
				<img class="parentDamage-icon" src='../../../assets/icon/remove-tag.svg' />
			</a>
		</div>
	</div>

	<!-- Svg report page -->
	<div class="row mt-2 mb-2 pt-2 pb-2 damageGroup" *ngIf="!inPlayer">
		<app-vehicle-svg class="d-inline-flex w-100" [settings]='settings' [activeSection]='activeSection'
			[damagesGroup]='damageGroups' [oneSide]='false' [inPlayer]='inPlayer'
			(editActiveSection)='activeSection = $event'>
		</app-vehicle-svg>
	</div>

	<!-- Damage row -->
	<div class="row p-0">
		<div (scroll)="elementOffset($event)" class="container scrollbox" id="scrollbox-damage" appScrollSpy
			[spiedTags]="['DIV']" [scrollOffset]="offsetScroll" [local]="true"
			(sectionChange)="onDamageSectionChange($event)">

			<div [ngClass]="{'active': openLocations.includes(groupData.svgLocation) || classificationIsActive}"
				*ngFor="let groupData of damageGroups" id="{{groupData.svgLocation}}-t" #parentLocation
				(click)='stopPropagation($event); setOpenLocations(groupData.svgLocation)'>

				<!-- Damage row  HEAD -->
				<div class="p-2 damageGroup headerDamage" id="{{groupData.svgLocation}}-h"
					*ngIf="groupData.newDamages || showParentDamage">
					<div class="row p-0 m-0">
						<div class="col-12">
							<span class="damage-subsection">{{groupData.location | vehicleLocation}}</span><span
								class="damage-count">
								({{groupData.damages.length}})</span>
						</div>
					</div>

					<div class="row p-0 m-0  justify-content-between">
						<div class="col-12 col-xl-7 m-0 p-0">
							<div class="col-12 center">
								<ul class="center">
									<li class="d-inline">
										<div (click)="colorclickGroup(groupData, $event)" class='colorclick'
											[ngClass]="groupData.severityPart ? (groupData.severityPart.severity ? groupData.severityPart.severity : '') : ''">
										</div>
										<p class="colorclickli"> {{groupData?.severityPart?.severity | vehicleSeverity}}
										</p>
									</li>
									<li *ngIf="groupData.severityPart && groupData.severityPart.cost">
										FRE : {{groupData.severityPart.cost}}€
									</li>
								</ul>
							</div>
						</div>

						<!-- responsive car svg -->
						<div class="d-none  col-xl-5 center d-xl-inline-flex justify-content-end"
							[ngClass]="{'m-0 p-0': inPlayer, 'm-0 pr-3' : !inPlayer}">
							<app-vehicle-svg *ngIf="!inPlayer" class="center" [settings]='settings'
								[activeSection]='activeSection' [damagesGroup]='[groupData]' [oneSide]='true'
								[inPlayer]='inPlayer'>
							</app-vehicle-svg>
							<app-vehicle-svg *ngIf="inPlayer" class="center" [settings]='settings' [activeSection]='""'
								[damagesGroup]='[groupData]' [oneSide]='true' [inPlayer]='inPlayer'>
							</app-vehicle-svg>
							<img style="cursor: pointer;" src='../../../assets/icon/chevron.svg'
								class="chevron center ml-2"
								[ngClass]="{'chevronRotate':  !(openLocations.includes(groupData.svgLocation))}">
						</div>
					</div>

					<!-- responsive car svg -->
					<div class="d-block d-xl-none row p-0 m-0 justify-content-end">
						<div class="col-12 col-xl-6 center d-inline-flex justify-content-end"
							[ngClass]="{'m-0 p-0': inPlayer, 'm-0 pr-3' : !inPlayer}">
							<app-vehicle-svg *ngIf="!inPlayer" class="center" [settings]='settings'
								[activeSection]='activeSection' [damagesGroup]='[groupData]' [oneSide]='true'
								[inPlayer]='inPlayer'>
							</app-vehicle-svg>
							<app-vehicle-svg *ngIf="inPlayer" class="center" [settings]='settings' [activeSection]='""'
								[damagesGroup]='[groupData]' [oneSide]='true' [inPlayer]='inPlayer'>
							</app-vehicle-svg>
							<img style="cursor: pointer" src='../../../assets/icon/chevron.svg'
								class=" chevron center ml-2"
								[ngClass]="{'chevronRotate':  !(openLocations.includes(groupData.svgLocation))}">
						</div>
					</div>

				</div>

				<!-- Damage list container -->
				<div class="col-12 damage-container" id="{{groupData.svgLocation}}-g"
					*ngIf="openLocations.includes(groupData.svgLocation) || _damageService.allOpenLocations || classificationIsActive">
					<div *ngFor="let damage of groupData.damages; let i = index" class="row damageGroup damage-row p-2"
						id={{damage.id}} [ngClass]="{
              'active-damage-row': selectedDamage?damage.id === selectedDamage.id:false,
              'damage-roi-added': (damage.isAuto !== true) && (damage.isDeleted !==true) && isSuperAdmin,
              'damage-roi-deleted': damage.isDeleted===true,
              'd-none' : damage.isParentDamage && showParentDamage === false}"
						(mouseenter)="handleDamageMouseEnter($event, damage)"
						(mouseleave)="handleDamageMouseLeave($event, damage)"
						(click)="handleRedirectToDamage(damage, undefined, $event)">

						<!-- Responsive  -->
						<div [ngClass]="inPlayer? 'col-12' :'col-12 col-md-5 col-lg-7'" class="p-0 m-0">
							<div class="row m-0 p-0">

								<!-- Damage header -->
								<div [ngClass]="inPlayer? 'col-12' :'col-4 col-md-12 col-lg-6'">
									<div class="row justify-content-between">
										<!-- Damage number -->
										<div class="col* ml-4">
											<span class="damage-cardinal">
												<!-- checkbox select damage 
                          <span class="checkmark"></span></label> -->

												<label class="checkbox-container "
													(click)="handleDamageToggleCheckbox($event, damage)">

													<input type="checkbox" [checked]="isCheckedDamage(damage)">
													<span class="checkmark"></span>

												</label>

												<!-- damage number + type -->
												<span class="damage-head"
													[ngClass]="{'newDamage': damage.isParentDamage == false, 'oldDamage' : damage.isParentDamage}">
													{{damage?.uid}} - {{damage?.type | vehicleDamage}}
													{{damage?.sev ? '- Niv: ' + damage.sev : ''}}</span>
												{{damage.inspected && isSuperAdmin ? "INSPECTED" : ''}}
												{{damage.ignoreIt && isSuperAdmin ? "IGNORE IT" : ''}}
											</span>
											<!-- damage proba + vue -->
											<span *ngIf="isSuperAdmin && damage.isAuto === true">
												({{damage?.percentBestRoi}}%)
												({{damage?.detectionCount}}x)
											</span>
											<p *ngIf="damage.deletedWithYolo">
												YOLO
											</p>

											<!-- damage vue for DCR -->
											<span *ngIf="currentUsername === 'dcr'">({{damage?.detectionCount}}x)</span>

										</div>
										<!-- Icons edit/delete -->
										<div class="col* d-inline-flex justify-content-end">
											<!-- Pen edit Player -->
											<img *ngIf="inPlayer && canEdit"
												(click)="modalpush($event, damage.id, 'edit')" class="icon"
												src='../../../assets/icon/pen-01.svg'>
											<!-- Remove Damage Player -->
											<img *ngIf="inPlayer && canEdit && damage.isDeleted !== true"
												(click)="modalpush($event, damage.id, 'delete')" class="icon"
												src='../../../assets/icon/remove.svg'>
										</div>
									</div>

								</div>

								<!-- Damage Data -->
								<div [ngClass]="inPlayer? 'col-12' : 'col-6 col-md-12 col-lg-6'">
									<ul>
										<li
											*ngIf="damage.isParentDamage && damage.parentPtr.tchekPtr && damage.parentPtr.tchekPtr.tchekCreatedAt ">
											Scan
											{{damage.parentPtr.tchekPtr.tchekCreatedAt | date:'medium'}}</li>
										<li *ngIf="damage.sizeRange"><span
												i18n="damage-analysis|@@damageSizeRange">Taille
												: </span>{{damage?.sizeRange | damageSizeRange}}
										</li>
										<li *ngIf="!damage.sizeRange && damage.radiusWorld"><span
												i18n="damage-analysis|@@damageSizeRange">Taille
												: </span>{{damage?.radiusWorld | damageSizeRange}}
										</li>
										<li *ngIf="damage.cost">FRE : {{damage.cost}}€
										</li>
										<li class="d-inline">
											<div (click)="colorclick(damage, $event)" class='colorclick'
												[ngClass]="damage.severity ? damage.severity : ''"></div>
											<p class="colorclickli"> {{damage?.severity | vehicleSeverity}}</p>
										</li>
									</ul>
								</div>

								<!-- responsive copy -->
								<div class="d-block d-md-none col-2 p-0 m-0 " *ngIf=" canEdit && !inPlayer">
									<div class="row p-0 m-0">
										<div class="col-12 pr-3 d-inline-flex justify-content-end"
											*ngIf="  damage.isDeleted !== true">
											<!-- Remove Damage report -->
											<img (click)="modalpush($event, damage.id, 'delete')" class="iconHeader"
												src='../../../assets/icon/remove.svg'>
										</div>
										<div class="col-12 pr-3 pt-3 d-inline-flex justify-content-end">
											<!-- Pen edit Report -->
											<img (click)="modalpush($event, damage.id, 'edit')" class="iconHeader"
												src='../../../assets/icon/pen-01.svg'>
										</div>
									</div>
								</div>

							</div>
						</div>

						<!-- Damage thumbnail and edit for report -->
						<div class="col-12 col-md-7 col-lg-5" *ngIf="!inPlayer">
							<div class="row justify-content-between">
								<div class="p-2 col-12 col-md-10">
									<app-thumbnail-damage
										*ngIf="(damage.bestImageUrl.mini || damage.roiPtr.imagePtr) && canDetection"
										[damage]="damage">
									</app-thumbnail-damage>
								</div>
								<div class="d-none d-md-block col-2 p-0 m-0 " *ngIf=" canEdit">
									<div class="row p-0 m-0" *ngIf="  damage.isDeleted !== true">
										<div class="col-12 pr-3 d-inline-flex justify-content-end">
											<!-- Remove Damage report -->
											<img (click)="modalpush($event, damage.id, 'delete')" class="icon"
												src='../../../assets/icon/remove.svg'>
										</div>
										<div class="col-12 pr-3 pt-3 d-inline-flex justify-content-end">
											<!-- Pen edit Report -->
											<img (click)="modalpush($event, damage.id, 'edit')" class="icon"
												src='../../../assets/icon/pen-01.svg'>
										</div>
									</div>
								</div>
							</div>
						</div>


						<!-- Roi image list for player -->
						<div class="col-12 m-2" *ngIf="inPlayer && damage.listRoi  ">
							<div class="roilistContainer">
								<ul class="roiContainer">

									<li *ngFor="let roi of damage.listRoi" class="roiBlock  d-none" #roiImageList>
										<!-- roi image -->
										<img crossorigin="anonymous" style="z-index: 11;" class='roiImage'
											(click)="handleRedirectToDamage(damage, roi, $event)" [ngClass]="{'selectedRoi': selectedRoi && selectedRoi.id === roi.id,
                  'isDeleted ' : roi.isDeleted ||( roi.imagePtr && roi.imagePtr.isDeleted)}" [src]="(roi.imagePtr !== undefined && roi.id !== undefined && roi.imagePtr.file )? 
                       roi.imagePtr.file.url() : roi.bestImageUrl.mini"
											(error)=" changeSource($event, roi,roiImageList)"
											(load)="roiImageList.classList.add('active'); roiImageList.classList.remove('d-none')" />

										<!-- best roi star selector -->
										<img style="z-index: 11;" class="icon star"
											*ngIf="roi.isDeleted !== true && roi.id === damage.roiPtr.id && canEdit && roiImageList.classList.contains('active')"
											src="../../../assets/icon/star_filled.svg" alt="">
										<img style="z-index: 10;" (click)='changeBestRoi(damage, roi, $event)'
											class="icon star"
											*ngIf="roi.isDeleted !== true && roi.id !== damage.roiPtr.id && canEdit &&  roiImageList.classList.contains('active')"
											src="../../../assets/icon/star_not_filled.svg" alt="">

									</li>

								</ul>
							</div>
						</div>

						<!-- Trace for superadmin -->
						<div *ngIf="showTraces">
							<div *ngFor="let trace of filterItemsOfType(damage.id)" class=" col-12 damage-trace">
								{{trace.get("action")}}
							</div>
						</div>

					</div>
				</div>
			</div>

		</div>
	</div>

	<!-- Footer button validate -->
 	<div id='footer-validate' class=" text-center" >
		<button *ngIf="inPlayer && report" class="btn btn-primary mt-2 mb-1" [routerLink]="['/report', report?.id]"
			i18n="roi_drawer|@@validateReport">Valider et editer le rapport</button>
	</div> 
</div>

<!-- Content Loader -->
<ng-template #contentLoader>
	<div class="row loader-wrapper">
		<div class="col-6">
			<content-loader [width]="300" [height]="160">
				<svg:rect id="rect3686" width="100%" height="160" x="0" y="0" rx="3" ry="3"
					style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
			</content-loader>
		</div>
		<div class="col-6">
			<content-loader [width]="300" [height]="160">
				<svg:rect id="rect3686" width="100%" height="160" x="0" y="0" rx="3" ry="3"
					style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
			</content-loader>
		</div>
	</div>
	<div class="container scrollbox">
		<div class="row">
			<div class="col-12">
				<span class="damage-subsection">
					<content-loader [width]="100" [height]="4">
						<svg:rect ry="1" rx="1" y="0" x="0" height="2" width="20" id="rect4512"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</span>
			</div>
		</div>
		<div class="row">
			<div class="col-2 col-lg-2">
			</div>
			<div class="col-10 col-lg-4">
				<content-loader [width]="100" [height]="8">
					<svg:rect ry="2" rx="2" y="0" x="0" height="4" width="60" id="rect4512"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
				</content-loader>
				<content-loader [width]="100" [height]="8">
					<svg:rect ry="2" rx="2" y="0" x="0" height="4" width="80" id="rect4512"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
				</content-loader>
				<content-loader [width]="100" [height]="8">
					<svg:rect ry="2" rx="2" y="0" x="0" height="4" width="70" id="rect4512"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
				</content-loader>
			</div>
			<div class="col-10 col-lg-4">
				<content-loader [width]="100" [height]="60">
					<svg:rect width="85" height="60" x="0" y="0" rx="2" ry="2"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.08601259;stroke-opacity:1" />
				</content-loader>
			</div>
			<div class="col-2 col-lg-2 text-center">
			</div>
		</div>
		<div class="row">
			<div class="col-2 col-lg-2">
			</div>
			<div class="col-10 col-lg-4">
				<content-loader [width]="100" [height]="8">
					<svg:rect ry="2" rx="2" y="0" x="0" height="4" width="60" id="rect4512"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
				</content-loader>
				<content-loader [width]="100" [height]="8">
					<svg:rect ry="2" rx="2" y="0" x="0" height="4" width="80" id="rect4512"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
				</content-loader>
				<content-loader [width]="100" [height]="8">
					<svg:rect ry="2" rx="2" y="0" x="0" height="4" width="70" id="rect4512"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
				</content-loader>
			</div>
			<div class="col-10 col-lg-4">
				<content-loader [width]="100" [height]="60">
					<svg:rect width="85" height="60" x="0" y="0" rx="2" ry="2"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.08601259;stroke-opacity:1" />
				</content-loader>
			</div>
			<div class="col-2 col-lg-2 text-center">
			</div>
		</div>
		<div class="row">
			<div class="col-2 col-lg-2">
			</div>
			<div class="col-10 col-lg-4">
				<content-loader [width]="100" [height]="8">
					<svg:rect ry="2" rx="2" y="0" x="0" height="4" width="60" id="rect4512"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
				</content-loader>
				<content-loader [width]="100" [height]="8">
					<svg:rect ry="2" rx="2" y="0" x="0" height="4" width="80" id="rect4512"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
				</content-loader>
				<content-loader [width]="100" [height]="8">
					<svg:rect ry="2" rx="2" y="0" x="0" height="4" width="70" id="rect4512"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
				</content-loader>
			</div>
			<div class="col-10 col-lg-4">
				<content-loader [width]="100" [height]="60">
					<svg:rect width="85" height="60" x="0" y="0" rx="2" ry="2"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.08601259;stroke-opacity:1" />
				</content-loader>
			</div>
			<div class="col-2 col-lg-2 text-center">
			</div>
			<div class="col-2 col-lg-2">
			</div>
			<div class="col-10 col-lg-4">
				<content-loader [width]="100" [height]="8">
					<svg:rect ry="2" rx="2" y="0" x="0" height="4" width="60" id="rect4512"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
				</content-loader>
				<content-loader [width]="100" [height]="8">
					<svg:rect ry="2" rx="2" y="0" x="0" height="4" width="80" id="rect4512"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
				</content-loader>
				<content-loader [width]="100" [height]="8">
					<svg:rect ry="2" rx="2" y="0" x="0" height="4" width="70" id="rect4512"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
				</content-loader>
			</div>
			<div class="col-10 col-lg-4">
				<content-loader [width]="100" [height]="60">
					<svg:rect width="85" height="60" x="0" y="0" rx="2" ry="2"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.08601259;stroke-opacity:1" />
				</content-loader>
			</div>
			<div class="col-2 col-lg-2 text-center">
			</div>
			<div class="col-2 col-lg-2">
			</div>
			<div class="col-10 col-lg-4">
				<content-loader [width]="100" [height]="8">
					<svg:rect ry="2" rx="2" y="0" x="0" height="4" width="60" id="rect4512"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
				</content-loader>
				<content-loader [width]="100" [height]="8">
					<svg:rect ry="2" rx="2" y="0" x="0" height="4" width="80" id="rect4512"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
				</content-loader>
				<content-loader [width]="100" [height]="8">
					<svg:rect ry="2" rx="2" y="0" x="0" height="4" width="70" id="rect4512"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
				</content-loader>
			</div>
			<div class="col-10 col-lg-4">
				<content-loader [width]="100" [height]="60">
					<svg:rect width="85" height="60" x="0" y="0" rx="2" ry="2"
						style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.08601259;stroke-opacity:1" />
				</content-loader>
			</div>
			<div class="col-2 col-lg-2 text-center">
			</div>
		</div>
	</div>
</ng-template>


// WEBPACK FOOTER //
// ./src/app/element/damage-analysis/damage-analysis.component.html